import { ILanguage } from 'src/app/core/interfaces';

export const getLangsList = () => FullLangsList;

export const DefaultLangsList: Array<ILanguage> = [
  {
    msLangIds: [19, 2067],
    code: 'nl',
    name: 'Nederlands',
    nativeName: 'Nederlands',
    voices: [
      { name: 'Claire', nativeName: 'Claire', locale: 'nl-NL', isDefault: true },
      { name: 'Ellen', nativeName: 'Ellen', locale: 'nl-BE', isDefault: false },
      { name: 'Xander', nativeName: 'Xander', locale: 'nl-NL', isDefault: false }
    ],
    availableForUI: true,
  },
  {
    msLangIds: [12, 1036],
    code: 'fr',
    name: 'French',
    nativeName: 'Français',
    voices: [
      { name: 'Amelie', nativeName: 'Amelie', locale: 'fr-CA', isDefault: true },
      { name: 'Chantal', nativeName: 'Chantal', locale: 'fr-CA', isDefault: false },
      { name: 'Nicolas', nativeName: 'Nicolas', locale: 'fr-CA', isDefault: false },
      { name: 'Audrey', nativeName: 'Audrey', locale: 'fr-FR', isDefault: false },
      { name: 'Aurelie', nativeName: 'Aurelie', locale: 'fr-FR', isDefault: false },
      { name: 'Thomas', nativeName: 'Thomas', locale: 'fr-FR', isDefault: false }
    ],
    availableForUI: true,
  },
  {
    msLangIds: [9, 12297],
    code: 'en',
    name: 'English',
    nativeName: 'English',
    voices: [
      { name: 'Daniel', nativeName: 'Daniel', locale: 'en-GB', isDefault: true },
      { name: 'Kate', nativeName: 'Kate', locale: 'en-GB', isDefault: false },
      { name: 'Malcolm', nativeName: 'Malcolm', locale: 'en-GB', isDefault: false },
      { name: 'Oliver', nativeName: 'Oliver', locale: 'en-GB', isDefault: false },
      { name: 'Serena', nativeName: 'Serena', locale: 'en-GB', isDefault: false },
      { name: 'Allison', nativeName: 'Allison', locale: 'en-US', isDefault: false },
      { name: 'Joelle', nativeName: 'Joelle', locale: 'en-US', isDefault: false },
      { name: 'Nathan', nativeName: 'Nathan', locale: 'en-US', isDefault: false },
      { name: 'Samantha', nativeName: 'Samantha', locale: 'en-US', isDefault: false },
      { name: 'Susan', nativeName: 'Susan', locale: 'en-US', isDefault: false },
      { name: 'Karen', nativeName: 'Karen', locale: 'en-AU', isDefault: false },
      { name: 'Lee', nativeName: 'Lee', locale: 'en-AU', isDefault: false },
      { name: 'Rishi', nativeName: 'Rishi', locale: 'en-IN', isDefault: false },
      { name: 'Sangeeta', nativeName: 'Sangeeta', locale: 'en-IN', isDefault: false },
      { name: 'Moira', nativeName: 'Moira', locale: 'en-IR', isDefault: false },
      { name: 'Evan', nativeName: 'Evan', locale: 'en-US', isDefault: false },
      { name: 'Tessa', nativeName: 'Tessa', locale: 'en-ZA', isDefault: false },
      { name: 'Stephanie', nativeName: 'Stephanie', locale: 'en-GB', isDefault: false },
      { name: 'Ava', nativeName: 'Ava', locale: 'en-US', isDefault: false },
      { name: 'Noelle', nativeName: 'Noelle', locale: 'en-US', isDefault: false },
      { name: 'Tom', nativeName: 'Tom', locale: 'en-US', isDefault: false },
      { name: 'Zoe', nativeName: 'Zoe', locale: 'en-US', isDefault: false },
    ],
    availableForUI: true,
  },
  {
    msLangIds: [7, 1031],
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch',
    voices: [
      { name: 'Anna', nativeName: 'Anna', locale: 'de-DE', isDefault: true },
      { name: 'Markus', nativeName: 'Markus', locale: 'de-DE', isDefault: false },
      { name: 'Petra', nativeName: 'Petra', locale: 'de-DE', isDefault: false },
      { name: 'Viktor', nativeName: 'Viktor', locale: 'de-DE', isDefault: false },
      { name: 'Yannick', nativeName: 'Yannick', locale: 'de-DE', isDefault: false },
    ],
    availableForUI: false,
  },
  // RTL languages is not supported now.
  // {
  //   msLangIds: 1,
  //   code: 'ar',
  //   name: 'Arabic',
  //   nativeName: 'العَرَبِيَّة',
  //   voices: [
  //     {name: 'Laila', nativeName: 'ليلى', locale: 'ar-SA', isDefault: true},
  //     {name: 'Maged', nativeName: 'ماجد', locale: 'ar-SA', isDefault: false},
  //     {name: 'Mariam', nativeName: 'مريم', locale: 'ar-SA', isDefault: false},
  //     {name: 'Tarik', nativeName: 'طارق', locale: 'ar-SA', isDefault: false},
  //   ]
  // },
  {
    msLangIds: [10, 1034],
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    voices: [
      { name: 'Jorge', nativeName: 'Jorge', locale: 'es-ES_tradnl', isDefault: true },
      { name: 'Marisol', nativeName: 'Marisol', locale: 'es-ES_tradnl', isDefault: false },
      { name: 'Monica', nativeName: 'Monica', locale: 'es-ES_tradnl', isDefault: false },
    ],
    availableForUI: false,
  },
  {
    msLangIds: [16, 1040],
    code: 'it',
    name: 'Italian',
    nativeName: 'Italiano',
    voices: [
      { name: 'Alice', nativeName: 'Alice', locale: 'it-IT', isDefault: true },
      { name: 'Federica', nativeName: 'Federica', locale: 'it-IT', isDefault: false },
      { name: 'Luca', nativeName: 'Luca', locale: 'it-IT', isDefault: false },
      { name: 'Paola', nativeName: 'Paola', locale: 'it-IT', isDefault: false },
    ],
    availableForUI: false,
  },
  {
    msLangIds: [21, 1045],
    code: 'pl',
    name: 'Polish',
    nativeName: 'Polskie',
    voices: [
      { name: 'Ewa', nativeName: 'Ewa', locale: 'pl-PL', isDefault: true },
      { name: 'Krzysztof', nativeName: 'Krzysztof', locale: 'pl-PL', isDefault: false },
      { name: 'Zosia', nativeName: 'Zosia', locale: 'pl-PL', isDefault: false },
    ],
    availableForUI: false,
  },
  {
    msLangIds: [22, 1046],
    code: 'pt',
    name: 'Portuguese',
    nativeName: 'Português',
    voices: [
      { name: 'Catarina', nativeName: 'Catarina', locale: 'pt-PT', isDefault: true },
      { name: 'Joana', nativeName: 'Joana', locale: 'pt-PT', isDefault: false },
      { name: 'Joaquim', nativeName: 'Joaquim', locale: 'pt-PT', isDefault: false },
    ],
    availableForUI: false,
  },
  {
    msLangIds: [31, 1050],
    code: 'tr',
    name: 'Turkish',
    nativeName: 'Türkçe',
    voices: [
      { name: 'Cem', nativeName: 'Cem', locale: 'tr-TR', isDefault: true },
      { name: 'Yelda', nativeName: 'Yelda', locale: 'tr-TR', isDefault: false },
    ],
    availableForUI: false,
  },
  {
    msLangIds: [25, 1049],
    code: 'ru',
    name: 'Russian',
    nativeName: 'Русский',
    voices: [
      { name: 'Katya', nativeName: 'Катя', locale: 'ru-RU', isDefault: true },
      { name: 'Milena', nativeName: 'Милена', locale: 'ru-RU', isDefault: false },
      { name: 'Yuri', nativeName: 'Юрий', locale: 'ru-RU', isDefault: false },
    ],
    availableForUI: false,
  },
  {
    msLangIds: [34, 1058],
    code: 'uk',
    name: 'Ukrainian',
    nativeName: 'Українська',
    voices: [
      { name: 'Lesya', nativeName: 'Леся', locale: 'uk-UA', isDefault: true },
    ],
    availableForUI: false,
  }

];

export const SkidbladnirLangsList: Array<ILanguage> = [
  {
    msLangIds: [19, 2067],
    code: 'nl',
    name: 'Nederlands',
    nativeName: 'Nederlands',
    voices: [
      { name: 'Mls', nativeName: 'Mls', locale: 'nl-NL', isDefault: true },
      { name: 'Nathalie', nativeName: 'Nathalie', locale: 'nl-BE', isDefault: false },
      { name: 'Rdh', nativeName: 'Rdh', locale: 'nl-BE', isDefault: false },
      { name: 'anna', nativeName: 'anna', locale: 'nl-BE', isDefault: false },
      { name: 'alex', nativeName: 'alex', locale: 'nl-NL', isDefault: false },
      { name: 'pim', nativeName: 'pim', locale: 'nl-NL', isDefault: false },
      { name: 'ronnie', nativeName: 'ronnie', locale: 'nl-NL', isDefault: false }
    ],
    availableForUI: true,
  },
  {
    msLangIds: [12, 1036],
    code: 'fr',
    name: 'French',
    nativeName: 'Français',
    voices: [
      { name: 'Upmc', nativeName: 'Upmc', locale: 'fr-FR', isDefault: false }
    ],
    availableForUI: true,
  },
  {
    msLangIds: [9, 12297],
    code: 'en',
    name: 'English',
    nativeName: 'English',
    voices: [
      { name: 'Northern English Male', nativeName: 'Northern English Male', locale: 'en-GB', isDefault: true },
      { name: 'Hfc Male', nativeName: 'Hfc Male', locale: 'en-US', isDefault: false },
      { name: 'Amy', nativeName: 'Amy', locale: 'en-US', isDefault: false },
      { name: 'semaine', nativeName: 'semaine', locale: 'en-GB', isDefault: false },
      { name: 'danny', nativeName: 'danny', locale: 'en-US', isDefault: false },
      { name: 'libritts_r', nativeName: 'libritts_r', locale: 'en-US', isDefault: false },
      { name: 'ryan', nativeName: 'ryan', locale: 'en-US', isDefault: false }
    ],
    availableForUI: true,
  },
  {
    msLangIds: [25, 1049],
    code: 'ru',
    name: 'Russian',
    nativeName: 'Русский',
    voices: [
      { name: 'Dmitri', nativeName: 'Дмитрий', locale: 'ru-RU', isDefault: true }
    ],
    availableForUI: false,
  }
];

export const FullLangsList: Array<ILanguage> = [
  {
    msLangIds: [19, 2067],
    code: 'nl',
    name: 'Nederlands',
    nativeName: 'Nederlands',
    voices: [
      { name: 'Claire', nativeName: 'Claire', locale: 'nl-NL', isDefault: true },
      { name: 'Ellen', nativeName: 'Ellen', locale: 'nl-BE', isDefault: false },
      { name: 'Xander', nativeName: 'Xander', locale: 'nl-NL', isDefault: false },
      { name: 'Mls', nativeName: 'Mls', locale: 'nl-NL', isDefault: true },
      { name: 'Nathalie', nativeName: 'Nathalie', locale: 'nl-BE', isDefault: false },
      { name: 'Rdh', nativeName: 'Rdh', locale: 'nl-BE', isDefault: false },
      { name: 'anna', nativeName: 'anna', locale: 'nl-BE', isDefault: false },
      { name: 'alex', nativeName: 'alex', locale: 'nl-NL', isDefault: false },
      { name: 'pim', nativeName: 'pim', locale: 'nl-NL', isDefault: false },
      { name: 'ronnie', nativeName: 'ronnie', locale: 'nl-NL', isDefault: false }
    ],
    availableForUI: true,
  },
  {
    msLangIds: [12, 1036],
    code: 'fr',
    name: 'French',
    nativeName: 'Français',
    voices: [
      { name: 'Amelie', nativeName: 'Amelie', locale: 'fr-CA', isDefault: true },
      { name: 'Chantal', nativeName: 'Chantal', locale: 'fr-CA', isDefault: false },
      { name: 'Nicolas', nativeName: 'Nicolas', locale: 'fr-CA', isDefault: false },
      { name: 'Audrey', nativeName: 'Audrey', locale: 'fr-FR', isDefault: false },
      { name: 'Aurelie', nativeName: 'Aurelie', locale: 'fr-FR', isDefault: false },
      { name: 'Thomas', nativeName: 'Thomas', locale: 'fr-FR', isDefault: false },
      { name: 'Upmc', nativeName: 'Upmc', locale: 'fr-FR', isDefault: false }
    ],
    availableForUI: true,
  },
  {
    msLangIds: [9, 12297],
    code: 'en',
    name: 'English',
    nativeName: 'English',
    voices: [
      { name: 'Daniel', nativeName: 'Daniel', locale: 'en-GB', isDefault: true },
      { name: 'Kate', nativeName: 'Kate', locale: 'en-GB', isDefault: false },
      { name: 'Malcolm', nativeName: 'Malcolm', locale: 'en-GB', isDefault: false },
      { name: 'Oliver', nativeName: 'Oliver', locale: 'en-GB', isDefault: false },
      { name: 'Serena', nativeName: 'Serena', locale: 'en-GB', isDefault: false },
      { name: 'Allison', nativeName: 'Allison', locale: 'en-US', isDefault: false },
      { name: 'Joelle', nativeName: 'Joelle', locale: 'en-US', isDefault: false },
      { name: 'Nathan', nativeName: 'Nathan', locale: 'en-US', isDefault: false },
      { name: 'Samantha', nativeName: 'Samantha', locale: 'en-US', isDefault: false },
      { name: 'Susan', nativeName: 'Susan', locale: 'en-US', isDefault: false },
      { name: 'Karen', nativeName: 'Karen', locale: 'en-AU', isDefault: false },
      { name: 'Lee', nativeName: 'Lee', locale: 'en-AU', isDefault: false },
      { name: 'Rishi', nativeName: 'Rishi', locale: 'en-IN', isDefault: false },
      { name: 'Sangeeta', nativeName: 'Sangeeta', locale: 'en-IN', isDefault: false },
      { name: 'Moira', nativeName: 'Moira', locale: 'en-IR', isDefault: false },
      { name: 'Evan', nativeName: 'Evan', locale: 'en-US', isDefault: false },
      { name: 'Tessa', nativeName: 'Tessa', locale: 'en-ZA', isDefault: false },
      { name: 'Stephanie', nativeName: 'Stephanie', locale: 'en-GB', isDefault: false },
      { name: 'Ava', nativeName: 'Ava', locale: 'en-US', isDefault: false },
      { name: 'Noelle', nativeName: 'Noelle', locale: 'en-US', isDefault: false },
      { name: 'Tom', nativeName: 'Tom', locale: 'en-US', isDefault: false },
      { name: 'Zoe', nativeName: 'Zoe', locale: 'en-US', isDefault: false },
      { name: 'Northern English Male', nativeName: 'Northern English Male', locale: 'en-GB', isDefault: true },
      { name: 'Hfc Male', nativeName: 'Hfc Male', locale: 'en-US', isDefault: false },
      { name: 'Amy', nativeName: 'Amy', locale: 'en-US', isDefault: false },
      { name: 'semaine', nativeName: 'semaine', locale: 'en-GB', isDefault: false },
      { name: 'danny', nativeName: 'danny', locale: 'en-US', isDefault: false },
      { name: 'libritts_r', nativeName: 'libritts_r', locale: 'en-US', isDefault: false },
      { name: 'ryan', nativeName: 'ryan', locale: 'en-US', isDefault: false }
    ],
    availableForUI: true,
  },
  {
    msLangIds: [7, 1031],
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch',
    voices: [
      { name: 'Anna', nativeName: 'Anna', locale: 'de-DE', isDefault: true },
      { name: 'Markus', nativeName: 'Markus', locale: 'de-DE', isDefault: false },
      { name: 'Petra', nativeName: 'Petra', locale: 'de-DE', isDefault: false },
      { name: 'Viktor', nativeName: 'Viktor', locale: 'de-DE', isDefault: false },
      { name: 'Yannick', nativeName: 'Yannick', locale: 'de-DE', isDefault: false },
    ],
    availableForUI: false,
  },
  // RTL languages is not supported now.
  // {
  //   msLangIds: 1,
  //   code: 'ar',
  //   name: 'Arabic',
  //   nativeName: 'العَرَبِيَّة',
  //   voices: [
  //     {name: 'Laila', nativeName: 'ليلى', locale: 'ar-SA', isDefault: true},
  //     {name: 'Maged', nativeName: 'ماجد', locale: 'ar-SA', isDefault: false},
  //     {name: 'Mariam', nativeName: 'مريم', locale: 'ar-SA', isDefault: false},
  //     {name: 'Tarik', nativeName: 'طارق', locale: 'ar-SA', isDefault: false},
  //   ]
  // },
  {
    msLangIds: [10, 1034],
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    voices: [
      { name: 'Jorge', nativeName: 'Jorge', locale: 'es-ES_tradnl', isDefault: true },
      { name: 'Marisol', nativeName: 'Marisol', locale: 'es-ES_tradnl', isDefault: false },
      { name: 'Monica', nativeName: 'Monica', locale: 'es-ES_tradnl', isDefault: false },
    ],
    availableForUI: false,
  },
  {
    msLangIds: [16, 1040],
    code: 'it',
    name: 'Italian',
    nativeName: 'Italiano',
    voices: [
      { name: 'Alice', nativeName: 'Alice', locale: 'it-IT', isDefault: true },
      { name: 'Federica', nativeName: 'Federica', locale: 'it-IT', isDefault: false },
      { name: 'Luca', nativeName: 'Luca', locale: 'it-IT', isDefault: false },
      { name: 'Paola', nativeName: 'Paola', locale: 'it-IT', isDefault: false },
    ],
    availableForUI: false,
  },
  {
    msLangIds: [21, 1045],
    code: 'pl',
    name: 'Polish',
    nativeName: 'Polskie',
    voices: [
      { name: 'Ewa', nativeName: 'Ewa', locale: 'pl-PL', isDefault: true },
      { name: 'Krzysztof', nativeName: 'Krzysztof', locale: 'pl-PL', isDefault: false },
      { name: 'Zosia', nativeName: 'Zosia', locale: 'pl-PL', isDefault: false },
    ],
    availableForUI: false,
  },
  {
    msLangIds: [22, 1046],
    code: 'pt',
    name: 'Portuguese',
    nativeName: 'Português',
    voices: [
      { name: 'Catarina', nativeName: 'Catarina', locale: 'pt-PT', isDefault: true },
      { name: 'Joana', nativeName: 'Joana', locale: 'pt-PT', isDefault: false },
      { name: 'Joaquim', nativeName: 'Joaquim', locale: 'pt-PT', isDefault: false },
    ],
    availableForUI: false,
  },
  {
    msLangIds: [31, 1050],
    code: 'tr',
    name: 'Turkish',
    nativeName: 'Türkçe',
    voices: [
      { name: 'Cem', nativeName: 'Cem', locale: 'tr-TR', isDefault: true },
      { name: 'Yelda', nativeName: 'Yelda', locale: 'tr-TR', isDefault: false },
    ],
    availableForUI: false,
  },
  {
    msLangIds: [25, 1049],
    code: 'ru',
    name: 'Russian',
    nativeName: 'Русский',
    voices: [
      { name: 'Katya', nativeName: 'Катя', locale: 'ru-RU', isDefault: true },
      { name: 'Milena', nativeName: 'Милена', locale: 'ru-RU', isDefault: false },
      { name: 'Yuri', nativeName: 'Юрий', locale: 'ru-RU', isDefault: false },
      { name: 'Dmitri', nativeName: 'Дмитрий', locale: 'ru-RU', isDefault: true }
    ],
    availableForUI: false,
  },
  {
    msLangIds: [34, 1058],
    code: 'uk',
    name: 'Ukrainian',
    nativeName: 'Українська',
    voices: [
      { name: 'Lesya', nativeName: 'Леся', locale: 'uk-UA', isDefault: true },
    ],
    availableForUI: false,
  }

];
